import React, {useEffect, useState} from 'react';

export default function Product({product, selectedProduct, handleSelectedProduct}) {

    const imageUrl = product.fields?.image?.url
    const price = product.fields?.price

    const [isSelected, setIsSelected] = useState(false)

    useEffect(() => {
        setIsSelected(selectedProduct?.id === product.id)
    }, [selectedProduct]);

    const selectProduct = () => {
        handleSelectedProduct(product)
    }

    return (
        <div className={"h-full bg-brand-light relative border-2 rounded-sm " + (product.recommended ? 'border-brand-blue' : 'border-brand-light')}>
            <div className={"radio-option"} key={product.id}>
                <input type="radio" name={"product"} id={`product-${product.id}`} value={product.id} className={"peer"} checked={isSelected} onChange={selectProduct}/>
                <label htmlFor={`product-${product.id}`}
                       className={"check border-none !rounded-none whitespace-nowrap overflow-hidden overflow-ellipsis " +
                           (product.recommended ? 'bg-brand-blue text-white' : 'bg-brand-green-light')}
                >
                    {price && (
                        <span className={"text-[20px] leading-[24px] lg:text-[24px] lg:leading-[28px] block font-bold " + (product.recommended ? 'text-brand-green' : 'text-brand-blue')}>{price}</span>
                    )}
                    <span className={"text-[15px] leading-[18px] lg:text-[18px] lg:leading-[28px] font-bold"}>{product.title}</span>
                    {product.recommended && (
                        <span className={"uppercase text-[12px] leading-[14px] lg:text-[14px] lg:leading-[28px] font-bold"}> - Recommended</span>
                    )}
                </label>
            </div>
            {imageUrl && (
                <div className={"w-full pb-[66%] relative cursor-pointer overflow-hidden"} onClick={selectProduct}>
                    <img src={imageUrl} alt={product.title} className={"absolute object-contain object-center"}/>
                    {isSelected && (
                        <div className={"absolute size-full bg-brand-green-light mix-blend-multiply"}></div>
                    )}
                </div>
            )}
        </div>
    )
}